'use client';

import type { FC, ReactNode } from 'react';
import Link from 'next/link';
import { useWikiGoal } from './useWikiGoal';

export const WikiShotCaseLink: FC<{ href: string; className?: string; children: ReactNode }> = ({ href, className, children }) => {
  const reachGoal = useWikiGoal();
  return (
    <Link href={href} className={className} onClick={() => reachGoal('wiki_shot_click')}>
      {children}
    </Link>
  );
};
